module.exports = __webpack_public_path__ + "static/media/main-business-03.6565e73.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-business-03.mp4
// module id = 0OIJ
// module chunks = 1